import { Box } from '@chakra-ui/react'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Copilot } from 'copilot/Copilot'
import type { PostHogConfig } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { PuzzelEvents } from 'PuzzelEvents'
import { type FC, type ReactNode, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import URLLayer from 'URLLayer'

import CapturiFooter from './components/CapturiFooter'
import CapturiThemeProvider from './components/CapturiThemeProvider'
import { POSTHOG_API_KEY } from './keys'
import { messages as messagesDa } from './locales/da/messages.mjs'
import { messages as messagesEn } from './locales/en/messages.mjs'
import { messages as messagesNo } from './locales/no/messages.mjs'
import { messages as messagesSe } from './locales/se/messages.mjs'
import { isFullMode } from './puzzelApi'
import PuzzelLayer from './PuzzelLayer'
import TestLayer from './TestLayer'
import { initAmplitude } from './utils/amplitude'

const queryClient = new QueryClient({})
const postHogOptions: Partial<PostHogConfig> = {
  api_host: 'https://posthog.capturi.ai',
  disable_session_recording: true,
  request_batching: true,
  autocapture: false,
  advanced_disable_flags: true,
  disable_external_dependency_loading: true,
}

const container = document.getElementById('app-root')

i18n.load({
  da: messagesDa,
  en: messagesEn,
  no: messagesNo,
  se: messagesSe,
})
i18n.activate('en')

// Initialize Amplitude
initAmplitude()

//poor mans router
const getCurrentRoute = () => {
  // if (isDev)
  //   return (
  //     <LegacyWrapper>
  //       <TestLayer />
  //     </LegacyWrapper>
  //   )
  //For legacy reasons; there are still som widgets on the puzzel-widget.capturi.ai subdomain
  const isPuzzel = window.location.host.includes('puzzel-widget')
  if (isPuzzel)
    return (
      <LegacyWrapper>
        <PuzzelLayer />
      </LegacyWrapper>
    )

  const path = window.location.pathname.split('/')[1] || ''
  switch (path) {
    case 'demo': {
      return (
        <LegacyWrapper>
          <TestLayer />
        </LegacyWrapper>
      )
    }
    case 'puzzel': {
      return (
        <LegacyWrapper>
          <PuzzelLayer />
        </LegacyWrapper>
      )
    }
    case 'events': {
      return <PuzzelEvents />
    }
    case 'copilot': {
      return <Copilot />
    }

    default: {
      return (
        <LegacyWrapper>
          <URLLayer />
        </LegacyWrapper>
      )
    }
  }
}

const LegacyWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <CapturiThemeProvider>
      <Box
        bg="greys.white"
        width="100vw"
        height="calc(100vh - 45px)" //45 is the footer height
        overflow="scroll"
      >
        {children}
      </Box>
      <CapturiFooter />
    </CapturiThemeProvider>
  )
}

// oxlint-disable-next-line typescript/no-non-null-assertion
const root = createRoot(container!)
root.render(
  <StrictMode>
    {isFullMode() ? (
      <PostHogProvider apiKey={POSTHOG_API_KEY} options={postHogOptions}>
        <QueryClientProvider client={queryClient}>
          <I18nProvider i18n={i18n}>{getCurrentRoute()}</I18nProvider>
        </QueryClientProvider>
      </PostHogProvider>
    ) : (
      <QueryClientProvider client={queryClient}>
        <I18nProvider i18n={i18n}>{getCurrentRoute()}</I18nProvider>
      </QueryClientProvider>
    )}
  </StrictMode>,
)
